import React, { useEffect, useState } from 'react';
import { Tag } from 'antd';
import api from '../api';

// Help Desk statuses -- their names, colours and categories -- are data now
// (Admin > Help Desk Workflows, GET /api/helpdesk/statuses). Read once per page
// load and shared; the built-in six are known up front so nothing waits on it.

const BUILT_IN = [
  { key: 'created',             name: 'Waiting for Support', category: 'open',    color: 'blue' },
  { key: 'in_progress',         name: 'In Progress',         category: 'open',    color: 'orange' },
  { key: 'waiting_on_customer', name: 'Waiting on Customer', category: 'waiting', color: 'purple' },
  { key: 'on_hold',             name: 'On Hold',             category: 'open',    color: 'default' },
  { key: 'completed',           name: 'Completed',           category: 'done',    color: 'green' },
  { key: 'canceled',            name: 'Canceled',            category: 'done',    color: 'default' },
];

let list = BUILT_IN;
let byKey = Object.fromEntries(BUILT_IN.map((s) => [s.key, s]));
let loading = null;
const listeners = new Set();

function set(rows) {
  list = rows;
  byKey = Object.fromEntries(rows.map((s) => [s.key, s]));
  listeners.forEach((fn) => fn(list));
}

export function loadHelpdeskStatuses(force = false) {
  if (!loading || force) {
    loading = api.get('/api/helpdesk/statuses').then((r) => set(r.data || BUILT_IN)).catch(() => { loading = null; });
  }
  return loading;
}

export const statusLabel = (key) => byKey[key]?.name ?? key ?? '';
export const statusColor = (key) => byKey[key]?.color ?? 'default';
export const isDoneStatus = (key) => byKey[key]?.category === 'done';
export const helpdeskStatuses = () => list;

// The statuses, re-rendering the caller once they arrive (or change).
export function useHelpdeskStatuses() {
  const [rows, setRows] = useState(list);
  useEffect(() => {
    listeners.add(setRows);
    loadHelpdeskStatuses();
    return () => { listeners.delete(setRows); };
  }, []);
  return rows;
}

export function HdStatusTag({ status, style }) {
  useHelpdeskStatuses();
  return <Tag color={statusColor(status)} style={style}>{statusLabel(status)}</Tag>;
}
